<div class="wrap-content w-full relative" (clickOutside)="handleClickOutSide()" #selectRef>
  <div class="select-area bg-neutral-14 border-green flex px-3 py-2" (click)="toggleOpen()">
    <div class="flex-full">{{ _activePlaceHolder }}</div>
    <img class="ml-auto block" [class.rotate-180]="!isOpen" src="assets/svg/select-box-up.svg" alt="" />
  </div>
  <!-- Dropdown menu -->
  <div class="w-full mt-1 left-0 absolute bg-neutral-06" [hidden]="!isOpen">
    <ul class="py-1 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownDefault">
      <ng-container *ngFor="let item of _list; let i = index">
        <li class="px-3 py-2 hover:bg-neutral-14 relative" (mouseup)="toggleSelect(item)">
          <div class="flex items-center">
            <input
              id="checkbox-{{ i }}"
              type="checkbox"
              [(ngModel)]="item.isSelect"
              [value]="item.value"
              class="w-4 h-4 text-primary bg-gray-100 rounded border-gray-300 focus:ring-teal-500 focus:ring-2"
            />
            <label for="checkbox-{{ i }}" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{ item.text }}</label>
          </div>
          <div class="absolute w-full h-full top-0 left-0"></div>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
